import clsx from 'clsx';
import { KeyboardEvent, useCallback, useMemo } from 'react';
import { ChevronLeft, ChevronRight } from 'react-feather';

import { KeyCode } from '@vestico/utils';

import { Button, CarouselArrowType, CustomCSSProperties } from '@vestico/shared';

import style from './FixedRowLayoutArrow.module.css';

export interface CarouselArrowProps {
  type: CarouselArrowType;
  onClick: () => void;
  hidden?: boolean;
  isRTL?: boolean;
  size?: number;
  round?: boolean;
  arrowSize?: number;
}

export const FixedRowLayoutArrow = ({ type, onClick, hidden, isRTL, size, round, arrowSize }: CarouselArrowProps) => {
  const previous = type === 'prev' && !isRTL;
  const customStyle = useMemo(() => {
    const newCustomStyle: CustomCSSProperties = {};
    if (size) {
      newCustomStyle['--vw-fixed-row-arrow-bg-size'] = `${size}px`;
    }
    if (arrowSize) {
      newCustomStyle['--vw-fixed-row-arrow-size'] = `${arrowSize}px`;
    }
    return newCustomStyle;
  }, [size, arrowSize]);

  const handleKeyUp = useCallback(
    (e: KeyboardEvent<HTMLDivElement>) => {
      e.preventDefault();
      e.stopPropagation();

      if (e.code === KeyCode.enter) {
        onClick();
      }
    },
    [onClick]
  );

  return (
    <div
      className={clsx(style.root, { [style.prev]: previous, [style.next]: !previous, [style.round]: round, [style.hidden]: hidden })}
      role="button"
      tabIndex={-1}
      onKeyUp={handleKeyUp}
      onClick={onClick}
      style={customStyle}
    >
      <Button plain onClick={onClick} content={previous ? <ChevronLeft /> : <ChevronRight />} noPadding />
    </div>
  );
};
